import {
    TimeTargetingDaysSelectType,
    TimeTargetingHoursSelectType,
    TimeTargetingShowSelectType
} from '../service/TimeTargetingEditorHelper/TimeTargetingEditorHelper';

import { Omit } from './utils';

export interface TimeZone {
    id: string;
    name: string;
}

export interface TimeZoneGroup {
    id: string;
    name: string;
    timezones: TimeZone[];
}

export interface TimeTargetingValue {
    timeBoard: number[][];
    rateCorrections?: number;
    useWorkingWeekends: boolean;
    holidaysSettings: TimeTargetingValueHolidaySettings;
    enabledHolidaysMode: boolean;
    idTimeZone: string;
    idTimeZoneGroup: string;
}

export type TimeTargetingEditorsState = Record<
    string,
    TimeTargetingEditorState
>;

export interface TimeTargetingEditorState
    extends Omit<TimeTargetingValue, 'holidaysSettings'> {
    isOpened: boolean;
    selectedDays: number[];
    currentDaysRangeItem?: TimeTargetingDaysMenuItem;
    currentHoursRangeItem: TimeTargetingHoursMenuItem;
    startTime: string;
    endTime: string;
    holidaysSettings: TimeTargetingEditorHolidaySettings;
    enabledHolidaysMode: boolean;
    idTimeZone: string;
    idTimeZoneGroup: string;
}

export interface TimeTargetingValueHolidaySettings {
    startHour: number;
    endHour: number;
    rateCorrections: number;
    isShow: boolean;
}

export interface TimeTargetingEditorHolidaySettings {
    isShow: boolean;
    startTime: string;
    endTime: string;
    currentHoursRangeItem: TimeTargetingHoursMenuItem;
    rateCorrections: number;
}

export enum TimeTargetingBoardItemRateCorrectionLevel {
    none = 'none',
    one = 'one',
    two = 'two',
    three = 'three',
    four = 'four'
}

export interface TimeTargetingSelectedItem {
    indexDay: number;
    indexHour: number;
}

export interface TimeTargetingDaysMenuItem {
    id: TimeTargetingDaysSelectType;
    text: string;
    listDays: number[];
}

export type TimeTargetingHoursMenuItem =
    | TimeTargetingHoursMenuItemHour24
    | TimeTargetingHoursMenuItemWorkTime
    | TimeTargetingHoursMenuItemRange
    | TimeTargetingHoursMenuItemArbitrary;

export interface TimeTargetingHoursMenuItemHour24
    extends TimeTargetingHoursRange {
    id: TimeTargetingHoursSelectType.HOUR24;
    text: string;
}

export interface TimeTargetingHoursMenuItemWorkTime
    extends TimeTargetingHoursRange {
    id: TimeTargetingHoursSelectType.WORK_TIME;
    text: string;
}

export interface TimeTargetingHoursMenuItemRange
    extends TimeTargetingHoursRange {
    id: TimeTargetingHoursSelectType.RANGE;
    text: string;
}

export interface TimeTargetingHoursMenuItemArbitrary {
    id: TimeTargetingHoursSelectType.ARBITRARY;
    text: string;
}

export interface TimeTargetingHoursRange {
    startHour: number;
    endHour: number;
}

export interface TimeTargetingTimeRange {
    startTime: string;
    endTime: string;
}

export interface TimeTargetingShowMenuItem {
    id: TimeTargetingShowSelectType;
    text: string;
    value: boolean;
}
